/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { C as Chip, d as defineCustomElement$1 } from './chip.js';

const CalciteChip = Chip;
const defineCustomElement = defineCustomElement$1;

export { CalciteChip, defineCustomElement };
